import React, { useState, useEffect } from "react"
import { Box, TextInput, Typography } from "@strapi/design-system"
import RangeSlider from "../RangeSlider/RangeSlider"

export type SliderSelectWithInputType = {
  title: string
  itemKey: string
  value: number
  initValue?: number
  inputOnChange: (key: string, value: number) => void
  max?: number
  min?: number
  offset?: number
  step?: number
  disabled?: boolean
}

const SliderSelectWithInput: React.FC<SliderSelectWithInputType> = ({
  title,
  itemKey,
  value,
  inputOnChange,
  offset,
  max = 10,
  min = 0,
  step,
  disabled = false,
}) => {
  const off = offset ?? 0
  const sliderValue = Math.max(min, Math.min(max, value - off))
  const [inputValue, setInputValue] = useState<string>(String(value - off))

  useEffect(() => {
    const numericValue = value - off
    const currentNumeric = parseFloat(inputValue)
    if (!isNaN(currentNumeric) && Math.abs(currentNumeric - numericValue) > 0.0001) {
      setInputValue(String(numericValue))
    }
  }, [value, off])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputStr = e.target.value

    if (inputStr === "" || inputStr === "-" || inputStr === "." || inputStr === "-.") {
      setInputValue(inputStr)
      return
    }

    const validNumber = /^-?\d*\.?\d*$/
    if (validNumber.test(inputStr)) {
      setInputValue(inputStr)
      const numValue = parseFloat(inputStr)
      if (!isNaN(numValue)) {
        inputOnChange(itemKey, numValue + off)
      }
    }
  }

  const handleInputBlur = () => {
    const numValue = parseFloat(inputValue)
    if (isNaN(numValue) || inputValue === "" || inputValue === "-" || inputValue === "." || inputValue === "-.") {
      setInputValue(String(value - off))
    } else {
      const clampedValue = Math.max(min, Math.min(max, numValue))
      setInputValue(String(clampedValue))
      inputOnChange(itemKey, clampedValue + off)
    }
  }

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 12,
        justifyContent: "center",
        alignItems: "center",
        padding: ".5rem",
        width: "100%",
      }}
    >
      <Typography variant="omega" fontWeight="bold" style={{ minWidth: "20px" }}>
        {title}
      </Typography>
      <Box style={{ flex: 1, minWidth: "150px" }}>
        <RangeSlider
          value={sliderValue}
          changeValue={(val) => inputOnChange(itemKey, val + off)}
          max={max}
          min={min}
          originAtCenter={min < 0}
          step={step}
        />
      </Box>
      <TextInput
        label=" "
        disabled={disabled}
        name={title}
        style={{ width: "70px" }}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        value={inputValue}
      />
    </Box>
  )
}

export default SliderSelectWithInput
